import React from 'react';
import { Box } from '@mui/material';
import { useHistory, useRouteMatch } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import InvButton from '../../components/InvButton';
import GoodsDiscardListPanel from '../../components/stock/GoodsDiscardListPanel';

export default function GoodsDiscardHub() {
  const history = useHistory();
  const { url } = useRouteMatch();
  const stockBase = url.replace(/\/goods-discard\/?$/, '');

  return (
    <Box>
      <PageHeader
        eyebrow="Inventory Management · Stock"
        title="Goods Discard"
        description="Permanently remove expired, damaged, or unusable inventory (draft → approve)"
        actions={(
          <InvButton variant="outlined" size="small" onClick={() => history.push(stockBase || `${url}/..`)}>
            Back to Stock
          </InvButton>
        )}
      />

      <GoodsDiscardListPanel />
    </Box>
  );
}
